<action class="button-inline underline"
        (click)="onClick()"
        [status]="status">
    <span class="cursor-pointer">{{'Clear All' | translate}}</span>
</action>
